export const NARRATE = 'NARRATE';
export const LOAD_PLAYER = 'LOAD_PLAYER';
export const PLAY = 'PLAY';
export const SET_ERROR = 'SET_ERROR';
export const SET_SUCCESS = 'SET_SUCCESS';
export const SET_LOADING = 'SET_LOADING';

export interface Article {
    id: string,
    title?: string,
    author?: string,
    source: string,
    duration: string,
    plays: number,
    likes: number,
    image: string,
    comments: number,
    narration_url?: URL,
    status?: string,
    created?: Date,
    updated?: Date,
}
export interface PlaylistItem extends Article {
    played?: boolean,
    archived?: boolean,
}
export interface ArticleState {
    article: Article | null;
    request_url: string,
    narrated: boolean;
    loading: boolean;
    error: string;
    success: string;
}

// Actions
interface NarrateAction {
    type: typeof NARRATE;
    payload: string;
}

interface LoadPlayerAction {
    type: typeof LOAD_PLAYER;
    payload: Article;
}

interface PlayerStatusAction {
    type: typeof PLAY;
    payload: boolean;
}

interface SetErrorAction {
    type: typeof SET_ERROR;
    payload: string;
}

interface SetSuccessAction {
    type: typeof SET_SUCCESS;
    payload: string;
}

interface SetLoadingAction {
    type: typeof SET_LOADING;
    payload: boolean;
}

export type ArticleAction = NarrateAction | SetLoadingAction | LoadPlayerAction | SetErrorAction | PlayerStatusAction | SetSuccessAction;
